import Card from "react-bootstrap/Card";

function getFirstWord(allWords) {
  if (allWords.length <= 14) return allWords;
  const allNames = allWords.split(" ");
  return allNames[0];
}

function Nafuda(props) {
  const { exam } = props;
  const { prev } = props;

  const items = ["left", "right", "top", "bottom", "center"];
  const backPosition = items[Math.floor(Math.random() * items.length)];

  let cardStyle = {
    maxWidth: "90px",
    writingMode: "vertical-rl",
    textOrientation: "upright",
    display: "inline-grid",
    maxHeight: "400px",
    minHeight: "250px",
    verticalAlign: "top",
    background: backPosition + " url(wood1.jpg)",
    marginBottom: "10px",
    marginRight: "2px",
  };

  let labelCard = <></>;
  if (prev?.grade != exam.grade) {
    let cardLabelStyle = { ...cardStyle };
    cardLabelStyle.background = "#3e3e3e";
    cardLabelStyle.color = "white";
    labelCard = (
      <Card id={exam.id} border="dark" style={cardLabelStyle}>
        <Card.Body style={{ display: "flex", padding: "1em" }}>
          <Card.Title style={{ margin: "0 4px 2rem 0" }}>
            {exam.grade}
          </Card.Title>
          <img alt="faa-logo" src="/faa-logo-big.png" width="31"></img>
        </Card.Body>
      </Card>
    );
  }

  return (
    <>
      {labelCard}
      <Card id={exam.id} border="dark" style={cardStyle}>
        <Card.Body
          style={{ padding: ".5rem .5rem .5rem 1em", letterSpacing: "-3px" }}
        >
          <Card.Text style={{ display: "inline", fontSize: "0.9em" }}>
            {exam.date}
          </Card.Text>
          <Card.Subtitle style={{ marginTop: "0.5rem", textAlign: "start" }}>
            {getFirstWord(exam.name)}
          </Card.Subtitle>
          <Card.Title style={{ textAlign: "start" }}>
            <span
              style={{ backgroundColor: "#80808029", padding: "5px 0 10px" }}
            >
              {getFirstWord(exam.lastname)}
            </span>
          </Card.Title>
        </Card.Body>
      </Card>
    </>
  );
}
export default Nafuda;
